module.exports = __webpack_public_path__ + "img/开放学堂logo_white.108754ce.png";